/** Normalize finish / color modifier labels for matching. */

export function normalizeFinishCode(raw: string | null | undefined): string {
  return String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function finishCodesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const left = normalizeFinishCode(a);
  const right = normalizeFinishCode(b);
  return Boolean(left) && left === right;
}
